import SvgIcon from '../SvgIcon';
import Tooltip from '../Tooltip';

export const DoorExitIcon = (): JSX.Element => {
  return (
    <SvgIcon viewBox="0 0 576 512">
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M3069 4771 l-29 -29 0 -2182 0 -2182 29 -29 c16 -16 40 -29 53 -29
13 0 375 105 806 234 846 252 824 243 858 323 21 48 21 3318 0 3366 -34 79
-12 71 -858 323 -431 129 -793 234 -806 234 -13 0 -37 -13 -53 -29z m539
-1918 c14 -10 35 -32 46 -47 20 -26 21 -41 21 -246 0 -241 -1 -243 -69 -294
-39 -29 -133 -29 -172 0 -67 49 -69 57 -72 267 -2 106 -1 206 3 224 7 40 49
91 90 109 40 19 120 12 153 -13z"
        />
        <path
          d="M1845 4631 c-90 -22 -172 -90 -215 -176 -25 -50 -25 -51 -28 -387
l-3 -338 25 -25 c24 -24 31 -25 136 -25 104 0 112 1 135 25 l25 24 0 296 0
295 375 0 376 0 24 25 c24 23 25 31 25 135 0 104 -1 112 -25 135 l-24 25 -398
-1 c-219 -1 -411 -4 -428 -8z"
        />
        <path
          d="M1933 3323 c-10 -4 -13 -66 -13 -264 l0 -259 -775 0 -776 0 -24 -25
c-25 -24 -25 -26 -25 -215 0 -189 0 -191 25 -215 l24 -25 776 0 775 0 0 -259
c0 -209 3 -260 14 -264 8 -3 158 139 392 374 209 209 381 384 383 390 3 11
-719 743 -749 758 -8 5 -21 6 -27 4z"
        />
        <path
          d="M1624 1415 l-25 -25 3 -338 c3 -327 4 -338 26 -382 35 -72 75 -114
144 -151 l63 -34 417 -3 418 -3 25 25 c24 24 25 31 25 136 0 104 -1 112 -25
135 l-24 25 -376 0 -375 0 0 295 0 296 -25 24 c-23 24 -31 25 -135 25 -105 0
-112 -1 -136 -25z"
        />
      </g>
    </SvgIcon>
  );
};
